import {
  Col,
  Row,
  Space,
  Table,
  Card,
  Spin,
  Select,
  DatePicker,
  message,
  Tooltip,
  Modal,
  Button,
  Cascader,
} from "antd";
import Search from "antd/es/input/Search";
import React, { useState, useEffect, useMemo } from "react";
import MotionHoc from "../../../utils/MotionHoc";
import { PrinterOutlined, SearchOutlined } from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";
import {
  HEADERS_EXPORT_BEN,
  POST_TERMINATE_CONTRACT_RECORD,
} from "../../API/apiUrls";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import DateCustom from "../../../hook/DateCustom";
import CurrencyFormat from "../../../hook/CurrencyFormat";
import { optionsLocat } from "../../../utils/constant/LocatOption";
import { ThaiRangePicker } from "../../../hook/ThaiDatePickerNew";
import { cancelCodeOptions } from "./constant/CancelCodeOption";

const Main = () => {
  const [convertDateThai, convertDateThaiShort] = DateCustom();
  const [
    currencyFormat,
    currencyFormatComma,
    currencyFormatPoint,
    currencyFormatNoPoint,
  ] = CurrencyFormat();
  const userCompany = localStorage.getItem("COMPANY_ID");
  const [loading, setLoading] = useState(false);
  const [arrData, setArrData] = useState([]);
  const [arrayTable, setArrayTable] = useState();
  const [tableLength, setTableLength] = useState(0);
  const ROLE_ID = localStorage.getItem("ROLE_ID");
  const [forPaySelect, setForPaySelect] = useState("116");
  const [optionsGCode, setOptionGCode] = useState();
  const [selectedGCode, setSelectedGCode] = useState([]);
  const [datePicker1, setDatePicker1] = useState([]);
  const [selectedContract, setSelectedContract] = useState(
    userCompany === "3" ? "rpsl" : "vsfhp"
  );
  const [arrow, setArrow] = useState("Show");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const { RangePicker } = DatePicker;
  const [optionsDataType, setOptionsDataType] = useState([]);
  const [rawData, setRawData] = useState();
  const [cancelCodeSelect, setCancelCodeSelect] = useState([]);
  let mockFCode;

  const onCascaderChange = (value, selectedOptions) => {
    console.log("value", value);
    setCancelCodeSelect(value);
    const [forPay, gcode] = value || [];
    setForPaySelect(forPay);
    setSelectedGCode(gcode);
  };

  useEffect(() => {
    let optionsContract = [];
    if (userCompany === "3") {
      optionsContract = [{ value: "rpsl", label: "ksm" }];
    } else {
      optionsContract = [
        { value: "lsfhp", label: "สัญญา 1" },
        { value: "vsfhp", label: "สัญญา 2" },
        { value: "psfhp", label: "สัญญา 3" },
        { value: "rpsl", label: "สัญญา 3(ใหม่)" },
        { value: "sfhp", label: "สัญญา 8" },
      ];
    }

    setOptionsDataType(optionsContract);
  }, []);

  useEffect(() => {
    let optionsGCodeData = [];

    if (forPaySelect === "116") {
      console.log("in");
      optionsGCodeData = [
        {
          label: <span>บอกเลิกสัญญาคนค้ำ(116)</span>,
          title: "บอกเลิกสัญญาคนค้ำ(116)",
          options: [
            { value: "P21", label: "P21" },
            { value: "P22", label: "P22" },
            { value: "P23", label: "P23" },
            { value: "P31", label: "P31" },
            { value: "P32", label: "P32" },
            { value: "P33", label: "P33" },
            { value: "P41", label: "P41" },
          ],
        },
      ];
    } else if (forPaySelect === "119") {
      optionsGCodeData = [
        {
          label: <span>บอกเลิกสัญญาผู้เช่าซื้อ(119)</span>,
          title: "บอกเลิกสัญญาผู้เช่าซื้อ(119)",
          options: [
            { value: "P11", label: "P11" },
            { value: "P12", label: "P12" },
            { value: "P13", label: "P13" },
          ],
        },
      ];
    } else {
      optionsGCodeData = [
        {
          label: <span>ค่าบอกเลิกสัญญา(ems)(129)</span>,
          title: "",
          options: [
            { value: "411", label: "411" },
            { value: "412", label: "412" },
            { value: "413", label: "413" },
            { value: "421", label: "421" },
            { value: "422", label: "422" },
            { value: "423", label: "423" },
            { value: "431", label: "431" },
            { value: "432", label: "432" },
            { value: "433", label: "433" },
            { value: "441", label: "441" },
            { value: "442", label: "442" },
            { value: "443", label: "443" },
            { value: "451", label: "451" },
            { value: "452", label: "452" },
            { value: "453", label: "453" },
            { value: "461", label: "461" },
            { value: "462", label: "462" },
            { value: "463", label: "463" },
          ],
        },
      ];
    }
    setOptionGCode(optionsGCodeData);
  }, [forPaySelect]);

  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") {
      return false;
    }
    if (arrow === "Show") {
      return true;
    }
    return {
      pointAtCenter: true,
    };
  }, [arrow]);

  const handleLoad = () => {
    console.log(datePicker1);

    console.log("load");
    if (selectedContract && datePicker1) {
      setForPaySelect(null);
      setSelectedGCode(null);
      setCancelCodeSelect([]);
      setRawData([]);
      loadData();
    } else {
      message.error("กรุณาเลือกสัญญาและวันที่ !! ");
    }
  };

  const loadData = async () => {
    setLoading(true);
    try {
      const res = await axios.post(
        POST_TERMINATE_CONTRACT_RECORD,
        {
          date1: dayjs(datePicker1?.[0]).format("YYYY-MM-DD"),
          date2: dayjs(datePicker1?.[1]).format("YYYY-MM-DD"),
          DATA_TYPE:
            selectedContract.value || (userCompany === "3" ? "rpsl" : "vsfhp"),
        },
        { headers: HEADERS_EXPORT_BEN }
      );

      if (res.status === 200) {
        console.log("setLawsuitData", res.data);
        filterData(res.data);
      } else {
        console.warn("ไม่สามารถดึงข้อมูลได้", res.status);
        message.error("ไม่มีข้อมูล");
        setArrayTable([]);
        setArrData([]);
      }
    } catch (error) {
      console.error("Error posting data:", error);
      const status = error.response?.status;
      const messageText =
        status && status >= 300
          ? `ไม่สามารถดึงข้อมูลได้ (status: ${status})`
          : `ไม่พบข้อมูล: ${error.message}`;
      message.error(messageText);
      setArrayTable([]);
      setArrData([]);
    } finally {
      setLoading(false);
    }
  };

  const mergeDataWithGuarantors = (data) => {
    console.log("mergeDataWithGuarantors");

    const mergedData = data.reduce((acc, record) => {
      const mainData = (record.address || []).map((addr) => ({
        ...record,
        cusType: 0,
        GCODE: record.GCODE,
        REGNO: record.REGNO,
        CONTNO: record.CONTNO, // เพิ่ม CONTNO ให้ชัดเจน
        NAME: `${record.SNAM} ${record.NAME1 || ""} ${
          record.NAME2 || ""
        }`.trim(),
        address: addr,
      }));

      const guarantorData = (record.guarantors || []).flatMap((guarantor) =>
        (guarantor.address || []).map((addr) => ({
          ...record,
          cusType: parseInt(guarantor.GARNO),
          NAME: `${guarantor.SNAM} ${guarantor.NAME1} ${guarantor.NAME2}`.trim(),
          address: addr,
        }))
      );

      return [...acc, ...mainData, ...guarantorData];
    }, []);

    // เรียงลำดับ CONTNO ก่อน แล้ว GARNO ทีหลัง
    const sortedData = mergedData.sort((a, b) => {
      const contnoComparison = a.CONTNO.localeCompare(b.CONTNO, undefined, {
        numeric: true,
      });
      if (contnoComparison !== 0) return contnoComparison; // เรียงตาม CONTNO ก่อน

      return (a.cusType || 0) - (b.cusType || 0); // GARNO: 0 (ลูกค้าหลัก) จะมาก่อน, จากนั้นเรียง 1, 2, 3...
    });

    // เพิ่ม key ให้แต่ละ record เริ่มจาก 1
    return sortedData.map((item, index) => ({
      ...item,
      key: index + 1, // เริ่ม key จาก 1
    }));
  };

  const filterData = (value) => {
    if (Array.isArray(value)) {
      let filteredDataCompany;

      if (userCompany === "3") {
        console.log("3");
        filteredDataCompany = value.filter((item) => {
          const branch = item.LOCAT;
          if (!branch) return true;
          return (
            !optionsLocat.some((opt) => branch.includes(opt.label)) ||
            item.CONTNO.includes("UD")
          );
        });
      } else {
        console.log("1");
        filteredDataCompany = value.filter((item) => {
          const branch = item.LOCAT;
          if (!branch) return false;
          return optionsLocat.some((opt) => branch.includes(opt.label));
        });
      }
      // dataContractUse = บช.ภายในตัดหนี้ 0
      let dataContractUse = filteredDataCompany.filter(
        (item) =>
          item.CONTNO?.substring(0, 1) !== "5" &&
          item.CONTNO?.substring(0, 1) !== "6" &&
          item.CONTNO?.substring(0, 1) !== "7"
      );
      setRawData(dataContractUse);
      console.log("dataContractUse", dataContractUse);

      let customData = mergeDataWithGuarantors(dataContractUse);

      setArrData(customData);
      setArrayTable(customData);
      setLoading(false);
    }
  };

  const handlefilterData = () => {
    setLoading(true);
    let dataFilter;
    let rawDataFilter;
    console.log("arrData", arrData);

    if (!forPaySelect || !selectedGCode) {
      setArrayTable(arrData);

      setTimeout(() => {
        setLoading(false);
      }, 250);
      return;
    }

    if (forPaySelect === "116") {
      console.log("if");
      dataFilter = arrData.filter(
        (item) =>
          (forPaySelect === item.FORCODE || item.FORCODE === "115") &&
          selectedGCode === item.GCODE &&
          item.cusType > 0
      );

      rawDataFilter = rawData.filter(
        (item) =>
          (forPaySelect === item.FORCODE || item.FORCODE === "115") &&
          selectedGCode === item.GCODE
      );
    } else {
      console.log("else");
      console.log("forPaySelect", forPaySelect);
      if (
        selectedGCode === "411" ||
        selectedGCode === "412" ||
        selectedGCode === "413" ||
        selectedGCode === "421" ||
        selectedGCode === "422" ||
        selectedGCode === "423"
      ) {
        dataFilter = arrData.filter(
          (item) =>
            forPaySelect === item.FORCODE &&
            selectedGCode === item.GCODE &&
            item.cusType > 0
        );
        rawDataFilter = rawData.filter(
          (item) =>
            forPaySelect === item.FORCODE &&
            selectedGCode === item.GCODE &&
            item.cusType > 0
        );
      } else {
        dataFilter = arrData.filter(
          (item) =>
            forPaySelect === item.FORCODE && selectedGCode === item.GCODE
        );
        rawDataFilter = rawData.filter(
          (item) =>
            forPaySelect === item.FORCODE && selectedGCode === item.GCODE
        );
      }
    }
    console.log("dataFilter--->", dataFilter);
    console.log("rawDataFilter", rawDataFilter);

    if (dataFilter?.length === 0) {
      message.error("ไม่พบข้อมูล");
    }

    let sortFilter = dataFilter.map((item, index) => ({
      ...item,
      key: index + 1, // เริ่ม key จาก 1
    }));
    setArrayTable(sortFilter);

    setTimeout(() => {
      setLoading(false);
    }, 250);
  };

  const search = (event) => {
    console.log("query--->", event.target.value);
    onSearch(event.target.value);
  };

  const onSearch = (value) => {
    setLoading(true);
    let result;

    if (value) {
      result = arrData.filter(
        (item) =>
          (item.CONTNO && item.CONTNO.includes(value.trim())) ||
          (item.NAME && item.NAME.includes(value.trim())) ||
          (item.NAME1 && item.NAME1.includes(value.trim())) ||
          (item.NAME2 && item.NAME2.includes(value.trim())) ||
          (item.REGNO && item.REGNO.includes(value.trim()))
      );
    } else {
      result = arrData;
      setCancelCodeSelect([]);
    }

    setTimeout(() => {
      setLoading(false);
    }, 250);

    setArrayTable(result);
  };

  const onClickDownload = () => {
    Modal.confirm({
      title: "ต้องการดาวน์ข้อมูล excel ?",
      okText: "ยืนยัน",
      cancelText: "ปิด",
      onOk: () => {
        createAndDownloadExcel();
      },
    });
  };

  const createAndDownloadExcel = async () => {
    // สร้าง Workbook
    const workbook = new ExcelJS.Workbook();
    let uniqueGCodes = [];
    // กำหนดประเภท GCODE ที่ต้องการแยก (ไม่ซ้ำกัน)
    if (selectedRows && selectedRows.length > 0) {
      uniqueGCodes = [...new Set(selectedRows.map((data) => data.GCODE))];
      console.log("selectedRows if1", uniqueGCodes);
    } else {
      uniqueGCodes = [...new Set(arrayTable.map((data) => data.GCODE))];
      console.log("arrayTable else1", uniqueGCodes);
    }

    // วนลูปสร้าง Sheet สำหรับแต่ละ GCODE
    uniqueGCodes.forEach((gCode) => {
      const worksheet = workbook.addWorksheet(`ประเภท ${gCode}`); // ใช้ GCODE เป็นชื่อ Sheet

      // กำหนดคอลัมน์ของ Worksheet
      worksheet.columns = [
        { header: "ลำดับ", key: "no", width: 10 },
        { header: "สัญญา", key: "data_type", width: 2 },
        { header: "ประเภทจ่าย", key: "forCode", width: 2 },
        { header: "ประเภทบัญชี", key: "gCode", width: 2 },
        { header: "รอบวันออกจดหมายในระบบ", key: "date", width: 20 },
        { header: "ยี่ห้อ", key: "type", width: 2 },
        { header: "ทะเบียน", key: "regNo", width: 2 },
        { header: "ค้างงวด", key: "overdue", width: 2 },
        { header: "เงินค้าง", key: "arrears", width: 2 },
        { header: "ค่าทวงถาม", key: "letter", width: 2 },
        { header: "ประเภทลูกค้า", key: "cusType", width: 10 },
        { header: "เลขที่สัญญา", key: "contno", width: 20 },
        { header: "ชื่อลูกค้า", key: "cusName", width: 30 },
        { header: "ที่อยู่", key: "addr", width: 35 },
        { header: "zipcode", key: "zipcode", width: 10 },
        { header: "ems จดหมาย", key: "emsNo", width: 25 },
        { header: "ems ใบตอบกลับ", key: "emsResponeNo", width: 25 },
      ];

      // กรองข้อมูลที่ตรงกับ GCODE
      let filteredData = [];

      if (selectedRows && selectedRows.length > 0) {
        filteredData = selectedRows.filter((data) => data.GCODE === gCode);
        console.log("selectedRows if2", filteredData);
      } else {
        filteredData = arrayTable.filter((data) => data.GCODE === gCode);
        console.log("arrayTable else2", filteredData);
      }

      // เพิ่มข้อมูลในแต่ละแถว
      filteredData.forEach((data, index) => {
        worksheet.addRow([
          index + 1,
          userCompany === "3" ? "ksm" : data.DATA_TYPE,
          parseInt(data.FORCODE),
          data.GCODE,
          dayjs(data.DOCDT).format("YYYY-MM-DD"), // วันที่ส่ง
          data.TYPE,
          data.REGNO,
          data.EXP_PRD,
          data.TOTPRC - data.SMPAY,
          data.LETTER,
          data.cusType,
          data.CONTNO,
          data.NAME,
          data.address.ADDR,
          data.address.ZIP,
        ]);
      });

      // จัดรูปแบบเซลล์ใน Worksheet
      worksheet.eachRow((row) => {
        row.eachCell((cell) => {
          cell.alignment = { vertical: "middle", horizontal: "center" }; // จัดกึ่งกลางแนวตั้งและแนวนอน
        });
      });
    });

    // สร้างไฟล์และดาวน์โหลด
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    let contract = optionsDataType.find(
      (item) => item.value === selectedContract
    );

    // ดาวน์โหลดไฟล์
    saveAs(
      blob,
      `รายงานบอกเลิกสัญญา${contract?.label}(${forPaySelect}) ${dayjs().format(
        "YYYY_MM_DD"
      )}.xlsx`
    );
  };

  const onSelectChange = (selectedRowKeys, selectedRows) => {
    console.log("selectedRowKeys changed: ", selectedRowKeys);
    setSelectedRowKeys(selectedRowKeys);
    console.log("Selected Row Keys:", selectedRowKeys); // คีย์ของแถวที่เลือก
    console.log("Selected Rows Data:", selectedRows); // ข้อมูลของแถวที่เลือก
    setSelectedRows(selectedRows); // เก็บข้อมูลแถวที่เลือกใน state;
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (rowKeys, selectedRows) => {
      onSelectChange(rowKeys, selectedRows);
    },
  };

  const columns = [
    {
      title: "ลำดับ",
      key: "index", // ใช้ key แทน dataIndex เพราะเราไม่ต้องการใช้ข้อมูลจาก data
      align: "center",
      render: (text, record, index) => (
        <>{index + 1}</> // ใช้ index ที่ถูกส่งมาจาก Table เพื่อเพิ่มลำดับแถว
      ),
    },
    {
      title: "วันที่ออกจดหมาย",
      align: "center",
      render: (record) => (
        <>
          {record.DOCDT
            ? dayjs(record.DOCDT).add(543, "year").format("D MMM YY")
            : null}
        </>
      ),
    },
    {
      title: "ประเภท",
      dataIndex: "GCODE",
      key: "GCODE",
      align: "center",
    },
    {
      title: "เลขที่สัญญา",
      dataIndex: "CONTNO",
      key: "CONTNO",
      align: "center",
    },
    {
      title: "ชื่อ-นามสกุล",
      dataIndex: "CUSTOMER",
      key: "CUSTOMER",
      align: "center",
      render: (text, record) => <>{record.NAME ? record.NAME : null}</>,
    },
    {
      title: "ประเภทลูกค้า",
      align: "center",
      render: (text, record) => (
        <>
          {record.cusType === 0 ? "ผู้เช่าซื้อ" : `ผู้ค้ำที่ ${record.cusType}`}
        </>
      ),
    },
    {
      title: "รายละเอียดรถ",
      dataIndex: "CONTNO",
      key: "CONTNO",
      align: "center",
      render: (text, record) => (
        <>
          {record.TYPE} <br />
          {record.REGNO}
        </>
      ),
    },
    {
      title: "ค้างงวด",
      dataIndex: "EXP_PRD",
      key: "EXP_PRD",
      align: "center",
      // render: (text, record) => (
      //   <>{record.LOAN.CONTNO ? record.LOAN.CONTNO : null}</>
      // ),
    },
    {
      title: "เงินค้าง",
      align: "center",
      render: (text, record) => (
        <>
          {currencyFormatPoint(record.TOTPRC - record.SMPAY)} <br />
        </>
      ),
    },
    {
      title: "ค่าทวงถาม",
      align: "center",
      render: (text, record) => <>{currencyFormatComma(record.LETTER)}</>,
    },
  ];

  return (
    <>
      <Card>
        <Row>
          <Col span={"14"} style={{ textAlign: "start" }}>
            <Select
              key={userCompany}
              size="large"
              style={{ minWidth: "auto", marginRight: 8 }}
              placeholder="เลือกสัญญา"
              popupMatchSelectWidth={false}
              labelInValue // ★ เปิดใช้
              value={selectedContract} // ต้องเป็น object { value, label }
              onChange={(obj) => setSelectedContract(obj ?? null)} // obj = { value, label }
              options={optionsDataType}
              allowClear
              showSearch
              optionFilterProp="label"
            />

            <Space size={16}>
              <ThaiRangePicker
                value={datePicker1}
                onChange={setDatePicker1}
                size="large"
              />
              <Button
                type="primary"
                icon={<SearchOutlined />}
                size="large"
                style={{
                  borderRadius: "8px",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                  fontWeight: "bold",
                  background: "linear-gradient(135deg, #667eea, blue)",
                  border: "none",
                }}
                onClick={handleLoad}
                disabled={loading}
              >
                ค้นหา
              </Button>
            </Space>
          </Col>
          <Col span={10} style={{ textAlign: "end", marginTop: "5px" }}>
            <Cascader
              value={cancelCodeSelect}
              options={cancelCodeOptions}
              onChange={onCascaderChange}
              placeholder="เลือกประเภทข้อมูล"
              allowClear
              showSearch
              size="large"
              style={{
                width: "auto",
                marginRight: "5px",
              }}
            />

            <Button
              type="default"
              // icon={<FilterOutlined />}
              size="large"
              style={{
                borderRadius: "8px",
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                fontWeight: "bold",
                backgroundColor: "#fff7d6",
                color: "#333",
                border: "1px solid #ffe58f",
              }}
              onClick={handlefilterData}
              disabled={loading}
            >
              กรองข้อมูล
            </Button>
          </Col>
          <Col span={12} style={{ marginTop: "5px" }}>
            <Tooltip placement="bottom" title="บันทึกข้อมูล Excel">
              <Button
                type="text"
                icon={
                  <PrinterOutlined
                    style={{ fontSize: "24px", color: "green" }}
                  />
                }
                onClick={onClickDownload}
                style={{
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                  borderRadius: "8px",
                  padding: "10px",
                  backgroundColor: "#f0fdf4",
                }}
              >
                พิมพ์
              </Button>
            </Tooltip>
          </Col>
          <Col span={12} style={{ textAlign: "end" }}>
            <Space size={16} style={{ marginTop: "10px" }}>
              <Search
                placeholder="ค้นหาสัญญา"
                enterButton
                onSearch={onSearch}
                style={{
                  width: "auto",
                  borderRadius: "8px",
                }}
                size="large"
              />
            </Space>
          </Col>
        </Row>
      </Card>
      <Card>
        <Spin spinning={loading} size="large" tip=" Loading... ">
          <Row>
            <Col span={"24"}>
              <Table
                style={{ marginTop: "10px" }}
                size="small"
                columns={columns}
                dataSource={arrayTable}
                rowSelection={rowSelection}
                scroll={{ x: 850 }}
                footer={() => (
                  <>
                    <p>จำนวนสัญญาที่เลือก {selectedRows?.length} </p> <br />
                    <p>จำนวนสัญญาที่ค้นหาทั้งหมด {arrayTable?.length} </p>
                  </>
                )}
              />
            </Col>
          </Row>
        </Spin>
      </Card>
    </>
  );
};

const CreateTerminateContract = MotionHoc(Main);
export default CreateTerminateContract;
